import moment from "moment";
import React from "react";
import { Modal } from "react-bootstrap";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
export default function PopUpShowImage({ open, onClose, image }) {
  // state

  // useEffect

  return (
    <Modal show={open} onHide={onClose} size="sm" centered>
      <Modal.Header
        closeButton
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          fontWeight: 700,
        }}
      >
        ເອກະສານຢືນຢັນ
      </Modal.Header>
      <Modal.Body
        style={{
          boxSizing: "border-box",
          overflow: "auto",
          width: "100%",
          padding: 20,
          paddingTop: 0,
        }}
      >
        <Zoom>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={image} alt="" style={{ width: "100%", height: "100%" }} />
          </div>{" "}
        </Zoom>
      </Modal.Body>
    </Modal>
  );
}
